import { Component, OnDestroy } from '@angular/core'
import { createAction, Store } from '@ngrx/store'
import { disable, DisableAction, FormGroupState } from 'ngrx-forms'
import { Observable, of } from 'rxjs'
import { selectAddressState } from '../user-addresses.state'
import { Address, CustomerInformationState, selectProfileState } from '../../user-profile/user-profile.state'
import { ActivatedRoute, Router } from '@angular/router'
import { catchError, tap } from 'rxjs/operators'
import { initialAddress } from '../user-addresses.reducers'
import { Subscriptions } from '../../../utils/subscriptions'
import { EditPage } from '../../../utils/services/can-deactivate-guard.service'
// import { Country } from '@angular-material-extensions/select-country'
import { HttpService } from '@api/http.service'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ErrorSnackBarComponent } from '../../../utils/components/error-snack-bar/error-snack-bar.component'
import { CustomerInfoActions } from '../../user-profile/user-profile.actions'
import {Country} from "../../../utils/components/select-country/select-country.component";

@Component({
  selector: 'cover-edit',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.scss'],
})
export class EditAddressComponent extends EditPage implements OnDestroy {
  selectedCountry: string = '' // alpha2Code
  formState$: Observable<FormGroupState<Address>>
  addressToEditState$: Observable<Address>
  userAddressState$: Observable<CustomerInformationState>
  userAddress: CustomerInformationState | undefined
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  constructor(
    private readonly store: Store,
    private readonly httpService: HttpService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly snackbar: MatSnackBar,
  ) {
    super()
    this.formState$ = store.select(selectAddressState.editPageControls)
    this.addressToEditState$ = store.select(selectAddressState.addressToEdit)
    this.userAddressState$ = this.store.select(selectProfileState.customerInformationState)
    this.subscriptions.plusOne = this.userAddressState$
      .pipe(
        tap(state => {
          this.userAddress = state

          this.store.dispatch(new DisableAction('address-edit-page.company'))

          if (this.userAddress?.address.company) {
            this.store.dispatch(new DisableAction('address-edit-page.street'))
            this.store.dispatch(new DisableAction('address-edit-page.street2'))
            this.store.dispatch(new DisableAction('address-edit-page.postalCode'))
            this.store.dispatch(new DisableAction('address-edit-page.city'))

            if (this.userAddress?.customerSubNumber === '0') {
              this.store.dispatch(new DisableAction('address-edit-page.firstName'))
              this.store.dispatch(new DisableAction('address-edit-page.lastName'))
            }
          }
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = this.addressToEditState$
      .pipe(
        tap(res => {
          if (JSON.stringify(res) === JSON.stringify(initialAddress)) {
            this.router.navigate(['../'], { relativeTo: this.route })
          } else {
            this.selectedCountry = res.countryCode
          }
        }),
      )
      .subscribe()
    this.subscriptions.plusOne = this.formState$
      .pipe(
        tap(formState => {
          this.formIsDirty = formState.isDirty
        }),
      )
      .subscribe()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  changeSelectedCountry(event: Country): void {
    if(!event) {
      this.selectedCountry = ''
      return
    }
    if (this.selectedCountry != event.alpha2Code) {
      this.selectedCountry = event.alpha2Code
      this.formIsDirty = true

    }
  }

  onSubmit(formState: FormGroupState<Address>): void {
    if ((formState.isDirty || this.formIsDirty) && formState.isValid && this.userAddress) {
      this.pending = true
      this.httpService
        .updateAddress({
          customer_number: this.userAddress.customerNumber,
          customer_sub_number: this.userAddress.customerSubNumber,
          first_name: formState.controls.firstName.value,
          last_name: formState.controls.lastName.value,
          mobile: this.userAddress.mobile,
          phone_number: this.userAddress.phoneNumber,
          postal_code: formState.controls.postalCode.value,
          street_2: formState.controls.street2.value,
          street: formState.controls.street.value,
          city: formState.controls.city.value,
          country_code: this.selectedCountry,
          company: formState.controls.company.value,
          email: this.userAddress.email,
          birthdate: this.userAddress.birthdate,
        })
        .pipe(
          tap(response => {
            this.pending = false
            if (response.parameter === 'success') {
              this.formIsDirty = false
              this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
                this.store.dispatch(CustomerInfoActions.customerInfoLoad({ payload: this.userAddress!.email }))
              })
            } else {
              this.snackbar.openFromComponent(ErrorSnackBarComponent, {
                duration: 5000,
                panelClass: ['error-snack-bar'],
              })
            }
          }),
          catchError(err => {
            this.pending = false
            this.snackbar.openFromComponent(ErrorSnackBarComponent, {
              duration: 5000,
              panelClass: ['error-snack-bar'],
            })
            return of(err)
          }),
        )
        .subscribe()
    }
  }
}
